import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import UpdateCurrencyConversionRateFormHandler from '../../containers/formHandlers/center/currency/updateCurrencyConversionRate/UpdateCurrencyConversionRateFormHandler';
import CurrencyDefinitionFormHandler from '../../containers/formHandlers/center/currency/currencyDefinition/CurrencyDefinitionFormHandler';
import ConsultCurrencyConversionRateFormHandler from '../../containers/formHandlers/center/currency/consultCurrencyConversionRate/ConsultCurrencyConversionRateFormHandler';


const Currency = () => {
  return (
    <CC.Tabs>
      <div style={{overflow: 'auto'}}>
        <CC.TabList>
          <CC.Tab minWidth={'fit-content'}>Definition devise</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>MAJ taux de conversion devise</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Consultation taux de conversion devise</CC.Tab>          
        </CC.TabList>
      </div>

      <CC.TabPanels>

        <CC.TabPanel>
          <CurrencyDefinitionFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <UpdateCurrencyConversionRateFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <ConsultCurrencyConversionRateFormHandler />
        </CC.TabPanel>

      </CC.TabPanels>
    </CC.Tabs>
  )
}

export default Currency;